import { Injectable } from '@angular/core';
import { ConfirmationModalComponent } from '@components/confirmation-modal/confirmation-modal.component';
import { leaveFormModalContent } from '@components/confirmation-modal/confirmationModalsData';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

@Injectable()
export class LeaveFormModalService {
  bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  confirmModal(): Observable<boolean> {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, {
      class: 'modal-dialog-centered modal-dialog-scrollable',
      initialState: leaveFormModalContent,
    });
    return this.bsModalRef.content.emitData;
  }
}
